import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import SbEditable from 'storyblok-react';
import LinkWrap from '../link_wrap';

const ImageResponsive = (props) => {
  const emptySrc = 'data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (props.blok.defer_image_load && !isLoaded) {
      setIsLoaded(true);
    }
  }, []);

  if (!props.blok.asset || !props.blok.asset.filename) {
    return <span>No asset defined.</span>;
  }

  const imgSrc = !props.blok.defer_image_load || isLoaded ? props.blok.asset.filename : emptySrc;

  if (props.blok.link_to && (props.blok.link_to.cached_url || props.blok.link_to.url)) {
    return (
      <SbEditable content={props.blok}>
        <LinkWrap
          to={props.blok.link_to}
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
          <ImgWrapper src={imgSrc} w={props.blok.max_width} h={props.blok.max_height} />
        </LinkWrap>
      </SbEditable>
    );
  } else {
    return (
      <SbEditable content={props.blok}>
        <ImgWrapper src={imgSrc} w={props.blok.max_width} h={props.blok.max_height} />
      </SbEditable>
    );
  }
};

export default ImageResponsive;

const ImgWrapper = styled((props) => <img {...props} alt="" />)`
  display: block;
  max-width: ${(props) => (props.w ? `min(100%,${props.w})` : 'none')};
  max-height: ${(props) => (props.h ? `min(100%,${props.h})` : 'none')};
  width: ${(props) => props.w || 'auto'};
  height: ${(props) => props.h || 'auto'};
`;
